/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TopGainersLosersQueryVariables = {|
  gainers: boolean
|};
export type TopGainersLosersQueryResponse = {|
  +topGainersLosers: ?$ReadOnlyArray<?{|
    +stock: ?{|
      +id: string,
      +name: string,
      +price: number,
      +politicianImage: ?string,
      +party: {|
        +partyName: string
      |},
    |},
    +profitLoss: ?number,
  |}>
|};
export type TopGainersLosersQuery = {|
  variables: TopGainersLosersQueryVariables,
  response: TopGainersLosersQueryResponse,
|};
*/


/*
query TopGainersLosersQuery(
  $gainers: Boolean!
) {
  topGainersLosers(gainers: $gainers) {
    stock {
      id
      name
      price
      politicianImage
      party {
        partyName
        id
      }
    }
    profitLoss
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "gainers"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "gainers",
    "variableName": "gainers"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "politicianImage",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partyName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profitLoss",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TopGainersLosersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GainerLoserNode",
        "kind": "LinkedField",
        "name": "topGainersLosers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PoliticiansNode",
            "kind": "LinkedField",
            "name": "stock",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PartyNode",
                "kind": "LinkedField",
                "name": "party",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TopGainersLosersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GainerLoserNode",
        "kind": "LinkedField",
        "name": "topGainersLosers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PoliticiansNode",
            "kind": "LinkedField",
            "name": "stock",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PartyNode",
                "kind": "LinkedField",
                "name": "party",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9dceb3de76421914cc16335b9fac3922",
    "id": null,
    "metadata": {},
    "name": "TopGainersLosersQuery",
    "operationKind": "query",
    "text": "query TopGainersLosersQuery(\n  $gainers: Boolean!\n) {\n  topGainersLosers(gainers: $gainers) {\n    stock {\n      id\n      name\n      price\n      politicianImage\n      party {\n        partyName\n        id\n      }\n    }\n    profitLoss\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6147b79b1feefbc219ab5d37877ce7ef';

module.exports = node;
